<template>
    <div class="newList">
        <navs></navs>
        <div class="banner">
            <banner :img="bannerImg" titleEn="News and information" titleCn="新闻资讯"></banner>
        </div>

        <div class="new_nav_list">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="热点咨询" name="first"></el-tab-pane>
                <el-tab-pane label="政策法规" name="second"></el-tab-pane>
                <el-tab-pane label="小包子课堂" name="third"></el-tab-pane>
                <el-tab-pane label="浙江橙兰动态" name="fourth"></el-tab-pane>
            </el-tabs>
        </div>

        <div class="new_list">
            <div class="new_item_box" v-for="item in newList" @click="goNewDetail(item.id)">
                <div class="new_item">
                    <div class="new_time">
                        <h4>{{[...item.createDate.matchAll(/(\d{4})-(\d{2})-(\d{2})/g)][0][3]}}</h4>
                        <p>{{[...item.createDate.matchAll(/(\d{4})-(\d{2})-(\d{2})/g)][0][1]}}-{{[...item.createDate.matchAll(/(\d{4})-(\d{2})-(\d{2})/g)][0][2]}}
                        </p>
                    </div>
                    <div class="new_text">
                        <div class="new_text_top">
                            <h3>{{item.title}}</h3>
                            <p><img src="@/assets/img/click.png">{{item.click}}</p>
                        </div>
                        <div class="new_text_bottom">
                            <p>{{item.summary}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fenyeBox">
                <el-pagination :current-page="page" background :page-sizes="[5, 10, 20, 50]" :page-size="limit"
                    :total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
                </el-pagination>
            </div>
        </div>
        <friend></friend>
        <foots  @navChange="initDw"></foots>
    </div>
</template>

<script>
    import friend from '@/components/friend.vue'
    import banner from '@/components/banner.vue'
    import navs from '@/components/navs.vue'
    import foots from '@/components/foots.vue'
    import bannerImg from '@/assets/img/new_banner.png'
    export default {
        name: 'newList',
        data() {
            return {
                bannerImg: bannerImg,
                activeName: 'first',
                page: 1,
                limit: 10,
                total: '',
                nowIndex: 0
            }
        },
        mounted() {
            this.initDw()
        },
        methods: {
            initDw() {
                window.scrollTo(0, 0);
                this.handleClick(0)
            },

            // 分页, 每页条数
            pageSizeChangeHandle(val) {
                this.page = 1
                this.limit = val
                this.handleClick(this.nowIndex)
            },
            // 分页, 当前页
            pageCurrentChangeHandle(val) {
                this.page = val
                this.handleClick(this.nowIndex)
            },




            handleClick(e) {
                let data
                if (e.index) {
                    this.nowIndex = e.index
                    this.page = 1
                } else {
                    this.nowIndex = e
                }



                if (this.nowIndex == 0) {
                    //热点资讯
                    data = {
                        page: this.page,
                        limit: this.limit,
                        categoryId: '1627852905191882754',
                        orderField: "release_time",
                        order: "desc"
                    }
                }
                if (this.nowIndex == 1) {
                    // 政策法规
                    data = {
                        page: this.page,
                        limit: this.limit,
                        categoryId: '1627852816637542401',
                        orderField: "release_time",
                        order: "desc"
                    }
                }
                if (this.nowIndex == 2) {
                    // 小包子课堂
                    data = {
                        page: this.page,
                        limit: this.limit,
                        categoryId: '1627852922644381698',
                        orderField: "release_time",
                        order: "desc"
                    }
                }
                if (this.nowIndex == 3) {
                    // 浙江橙兰动态
                    data = {
                        page: this.page,
                        limit: this.limit,
                        categoryId: '1627852793673728002',
                        orderField: "release_time",
                        order: "desc"
                    }
                }


                this.$http.get(`/attract_investment/front/show/newsList`, {
                    params: {
                        ...data
                    }
                }).then(({
                    data: res
                }) => {
                    this.total = res.total
                    this.newList = res.list
                    this.$forceUpdate()
                })
            },
            //跳转到新闻内页
            goNewDetail(id) {
                this.$router.push({
                    path: '/newDetail',
                    query: {
                        id,
                    }
                });
            },
        },
        components: {
            navs,
            foots,
            banner,
            friend
        }
    }
</script>
<style lang="scss" scoped>
    .new_list {
        padding: 48px 0 80px;
    }

    .new_item {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 1400px;
        margin: 0 auto;
    }

    .new_item_box {
        padding: 26px 0;
    }

    .new_item_box:hover {
        background: rgba(240, 131, 0, 0.03);
    }

    .new_time {
        background: #F08300;
        padding: 10px;
        color: #fff;
        width: 80px;
        height: 80px;
        box-sizing: border-box;
        border-radius: 10px;

        h4 {
            font-size: 26px;
            font-weight: 400;
            margin: 0;
            margin-bottom: 5px;
        }

        p {
            font-size: 14px;
            font-weight: 400;
            margin: 0;
        }
    }

    .new_text {
        width: 90%;
        margin-left: 32px;
        text-align: left;
        padding: 8px 0;

        h3 {
            margin: 0;
            margin-bottom: 15px;
            font-size: 18px;
            color: #333;
        }

        p {
            margin: 0;
            font-size: 16px;
            color: #666;
            height: 20px;
            overflow: hidden;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .new_nav_list {
        padding: 50px 0 40px;
    }

    .new_text_top {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        p {
            color: #C2C2C2;
            font-size: 16px;
            overflow: inherit;

            img {
                display: inline-block;
                margin-bottom: -6px;
                margin-right: 10px;
            }
        }
    }

    .fenyeBox {
        margin-top: 80px;
    }
</style>
<style lang="scss">
    .el-select-dropdown__item.selected {
        color: #F08300 !important;
    }

    .fenyeBox {
        .el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #F08300;
        }

        .el-pagination.is-background .el-pager li:not(.disabled):hover {
            color: #F08300;
        }

        .el-pagination__sizes .el-input .el-input__inner:hover {
            border-color: #F08300;
        }

        .el-select .el-input.is-focus .el-input__inner {
            border-color: #F08300;
        }
    }

    .new_nav_list {
        .el-tabs__nav-scroll {
            width: 590px;
            margin: 0 auto !important;
        }

        .el-tabs__item {
            padding: 0 40px;
        }

        .el-tabs__item:hover {
            color: #F08300;
        }

        .el-tabs__nav-wrap::after {
            height: 0;
        }

        .el-tabs__item.is-active {
            color: #F08300;
        }

        .el-tabs__active-bar {
            background-color: #F08300;
        }

        .el-tabs__item {
            font-size: 18px;
            color: #666;
        }
    }
</style>